import React from 'react'
import ReactDOM from 'react-dom/client'
import { initColorMode } from '@diwata/ironvale'
import App from './App'
import './components/layout.css'

document.documentElement.setAttribute('data-theme', 'conclave')
initColorMode()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
